export default {
    message: "Položky uvedené níže nejsou skladem a byly odstraněny z vašeho košíku. Proveďte jiný výběr.",
    buttons: {
        ok: "OK"
    }
}